<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003600.filtration.controle.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="[
        {
          ref: 1,
          label: 'P0003600.filtration.controle.fonctionnement.on' | translate,
          icon: 'fa-kit fa-picto-on',
          color: 'color-green',
        },
        {
          ref: 0,
          label: 'P0003600.filtration.controle.fonctionnement.off' | translate,
          icon: 'fa-kit fa-picto-off',
          color: 'color-red',
        },
        {
          ref: 2,
          label: 'P0003600.filtration.controle.fonctionnement.auto' | translate,
          icon: 'fa-kit fa-picto-programme',
          color: 'color-orange',
        },
      ]"
      [value]="this.actionStack!.getValue('fsCModeFonctionnement')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.FiltrationStandard_Controle,
          'fsCModeFonctionnement',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>

<div class="my-2 mb-4">
  <div class="row align-items-center">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003600.filtration.controle.programme' | translate
      }}</ion-label>
    </div>
    <div class="col-auto">
      <div class="p-2 pointer-hover" (click)="openenSavoirPlus()">
        <i class="fa-regular fa-info-circle color-primary"></i>
      </div>
    </div>
  </div>
  <div class="my-3">
    <div class="row justify-content-center align-items-center">
      <div class="col-4 mb-3">
        <div
          class="programme-button pointer-hover color-medium"
          (click)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.FiltrationStandard_Controle,
              'fsCProgrammeFiltrationAuto',
              0
            );
            this.actionStack!.commit()
          "
        >
          <div class="row h-100 align-items-center">
            <div
              class="col text-center"
              [class.color-primary]="
                actionStack!.getValue('fsCProgrammeFiltrationAuto') === 0
              "
            >
              <div>
                <i class="fa-kit fa-picto-usine-1 fs-36"></i>
              </div>
              <div class="text-uppercase">
                {{ 'P0003600.filtration.controle.usine1' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4 mb-3">
        <div
          class="programme-button pointer-hover color-medium"
          (click)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.FiltrationStandard_Controle,
              'fsCProgrammeFiltrationAuto',
              1
            );
            this.actionStack!.commit()
          "
        >
          <div class="row h-100 align-items-center">
            <div
              class="col text-center"
              [class.color-primary]="
                actionStack!.getValue('fsCProgrammeFiltrationAuto') === 1
              "
            >
              <div>
                <i class="fa-kit fa-picto-usine-2 fs-36"></i>
              </div>
              <div class="text-uppercase">
                {{ 'P0003600.filtration.controle.usine2' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4 mb-3">
        <div
          class="programme-button pointer-hover color-medium"
          (click)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.FiltrationStandard_Controle,
              'fsCProgrammeFiltrationAuto',
              2
            );
            this.actionStack!.commit()
          "
        >
          <div class="row h-100 align-items-center">
            <div
              class="col text-center"
              [class.color-primary]="
                actionStack!.getValue('fsCProgrammeFiltrationAuto') === 2
              "
            >
              <div>
                <i class="fa-kit fa-picto-usine-3 fs-36"></i>
              </div>
              <div class="text-uppercase">
                {{ 'P0003600.filtration.controle.usine3' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4 mb-3">
        <div
          class="programme-button pointer-hover color-medium"
          (click)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.FiltrationStandard_Controle,
              'fsCProgrammeFiltrationAuto',
              3
            );
            this.actionStack!.commit()
          "
        >
          <div class="row h-100 align-items-center">
            <div
              class="col text-center"
              [class.color-primary]="
                actionStack!.getValue('fsCProgrammeFiltrationAuto') === 3
              "
            >
              <div>
                <i class="fa-kit fa-picto-horlogehiver fs-36"></i>
              </div>
              <div class="text-uppercase">
                {{ 'P0003600.filtration.controle.hiver' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4 mb-3">
        <div
          class="programme-button pointer-hover color-medium"
          (click)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.FiltrationStandard_Controle,
              'fsCProgrammeFiltrationAuto',
              4
            );
            this.actionStack!.commit()
          "
        >
          <div class="row h-100 align-items-center">
            <div
              class="col text-center"
              [class.color-primary]="
                actionStack!.getValue('fsCProgrammeFiltrationAuto') === 4
              "
            >
              <div>
                <i class="fa-kit fa-picto-horlogeete fs-36"></i>
              </div>
              <div class="text-uppercase">
                {{ 'P0003600.filtration.controle.ete' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4 mb-3">
        <div
          class="programme-button pointer-hover color-medium"
          (click)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.FiltrationStandard_Controle,
              'fsCProgrammeFiltrationAuto',
              5
            );
            this.actionStack!.commit()
          "
        >
          <div class="row h-100 align-items-center">
            <div
              class="col text-center"
              [class.color-primary]="
                actionStack!.getValue('fsCProgrammeFiltrationAuto') === 5
              "
            >
              <div>
                <i class="fa-kit fa-picto-horloge72h fs-36"></i>
              </div>
              <div class="text-uppercase">
                {{
                  actionStack!.getValue('fsCProgrammeFiltrationAuto') === 5
                    ? convertSecondsToTime(
                        actionStack!.getValue('fsSCompteARebours72H')
                      )
                    : ('P0003600.filtration.controle.72h' | translate)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (
        actionStack!.getValue('fsSTemperatureReferenceDisponibleLoiDEau') === 1
      ) {
        <div class="col-4 mb-3">
          <div
            class="programme-button pointer-hover color-medium"
            (click)="
              this.actionStack!.editValue(
                P00039DataRxTxIndex.FiltrationStandard_Controle,
                'fsCProgrammeFiltrationAuto',
                6
              );
              this.actionStack!.commit()
            "
          >
            <div class="row h-100 align-items-center">
              <div
                class="col text-center"
                [class.color-primary]="
                  actionStack!.getValue('fsCProgrammeFiltrationAuto') === 6
                "
              >
                <div>
                  <i class="fa-kit fa-picto-auto fs-36"></i>
                </div>
                <div class="text-uppercase">
                  {{ 'P0003600.filtration.controle.loideau' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
